import { TableDataType } from '../../../designComponents/Table';
import theme from '../../../theme';

export const mainHeadData = [
  {
    city: 'Ireland',
    country: 'Dublin',
    postalCode: 'A65 F4E2',
    invoiceNumber: '#328',
    date: '2023/11/26',
    invoiceDueDate: '2023 / 11 / 26',
    email: 'escapepalnpro@gmail.com',
  },
];

export const billShipData = [
  {
    clientName: 'Sachin Bhattarai',
    emailAddress: 'sachinbhattarai.client@gmail.com',
    billAddress: 'Narephat, Jadibuti, Kathmandu',
    city: 'Kathmandu',
    country: 'Nepal',
    postalCode: '44600',
    name: 'Sachin Bhattarai',
    shipAddress: 'Narephat, Jadibuti, Kathmandu',
    phone: '+977 9868975645',
  },
];
const applyHeadingColor = () => {
  return {
    color: theme.colors.white,
    // paddingLeft: '20px',
  };
};

export const tableData: TableDataType = {
  headings: [
    {
      key: 'serialNumber',
      label: 'S.N.',
      style: applyHeadingColor(),
    },
    {
      key: 'item',
      label: 'ITEM',
      style: applyHeadingColor(),
    },
    {
      key: 'package',
      label: 'PACKAGE',
      style: applyHeadingColor(),
    },
    {
      key: 'desc',
      label: 'DESCRIPTION',
      style: applyHeadingColor(),
    },
    {
      key: 'quantity',
      label: 'QUANTITY',
      style: applyHeadingColor(),
    },
    {
      key: 'amount',
      label: 'AMOUNT',
      style: applyHeadingColor(),
    },
    {
      key: 'price',
      label: 'PRICE',
      style: applyHeadingColor(),
    },
  ],
  body: [
    {
      id: '1',
      serialNumber: '1.',
      item: 'Evacuation plan for hotel',
      package: 'Standard  Package ',
      desc: 'Description',
      quantity: '4',
      amount: '€20.00',
      price: '€40.00',
    },
    {
      id: '2',
      serialNumber: '2.',
      item: 'Evacuation plan for hotel',
      package: 'Standard  Package ',
      desc: 'Description',
      quantity: '4',
      amount: '€20.00',
      price: '€40.00',
    },
    {
      id: '3',
      serialNumber: '3.',
      item: 'Evacuation plan for hotel',
      package: 'Standard  Package ',
      desc: 'Description',
      quantity: '4',
      amount: '€20.00',
      price: '€40.00',
    },
  ],
};
